// extracted by mini-css-extract-plugin
export var alignLeft = "G_rd d_fp d_bG d_dv";
export var alignCenter = "G_bP d_fq d_bD d_dw";
export var alignRight = "G_rf d_fr d_bH d_dx";
export var container = "G_mw d_dW d_Z";
export var containerFull = "G_r0 d_dT d_Z";
export var images = "G_vV";
export var image = "G_vW d_w d_H d_bd d_0 d_8 d_7 d_4 d_9 d_dy";
export var imageWrapper = "G_rj";
export var design1 = "G_vX";